<template>
  <basic-container></basic-container>
</template>

<script>
export default {
  data() {
    return {}
  },
  created() {
    window.location.href = 'https://admin.dbzdjk.com/index.php?r=admin/auth/login&login_type=YWRtaW4='
  }
}
</script>
